import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MultiSelectPayload, Option } from '../../interfaces';
import { BotChatCard } from '@/shared/components';
import { BotChatCardType } from '@/shared/enums/botChatCardType.enum';

@Component({
  selector: 'bevvi-multiselect-payload',
  imports: [BotChatCard],
  templateUrl: './multiselect-payload.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultiselectPayloadComponent {
  public readonly payload = input.required<MultiSelectPayload>();
  public readonly disabled = input(false);

  public readonly userReply = output<string>();

  protected selectedOptions: Option[] = [];
  protected readonly type = BotChatCardType;

  public onOptionChange(options: Option[]): void {
    this.selectedOptions = options;
  }

  public onSubmit(): void {
    const labels = this.selectedOptions.filter((o) => o.selected).map((o) => o.label);
    if (labels.length) {
      this.userReply.emit(labels.join(', '));
    }
  }
}
